// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"365":"cb355538","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"365":"31626a4618c8cffa3bfb","678":"f4048801a596f1fcf266","883":"b5c49304b19e22e7f1f6"}[chunkId] + ".js";
};